module.exports = __webpack_public_path__ + "img/orange_131.23dda06b.png";